import React from "react";

const PrivacyPolicyFr = () => {
  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-center text-3xl font-bold mb-6">
        POLITIQUE DE CONFIDENTIALITÉ
      </h1>
      <p className="text-center text-lg mb-6">
        ANANAS SOLUTIONS – Un produit de Ananas Acti-Solutions inc.
      </p>
      <p className="text-center mb-4">
        <strong>Date de dernière mise à jour : 2 octobre 2025</strong>
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          1. Responsable de la protection des renseignements personnels
        </h2>
        <p>
          Le responsable de la protection des renseignements personnels pour{" "}
          <strong>Ananas Acti-Solutions inc.</strong> peut être contacté à :{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          2. Renseignements personnels collectés
        </h2>
        <p>Nous pouvons collecter les renseignements suivants :</p>
        <ul className="list-disc ml-8">
          <li>Nom, prénom, adresse courriel et numéro de téléphone</li>
          <li>Adresse postale et informations de facturation</li>
          <li>Données de connexion (adresse IP, logs, cookies)</li>
          <li>Préférences, historique de navigation et interactions</li>
          <li>Informations relatives aux paiements et transactions</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Finalités</h2>
        <p>Vos données peuvent être utilisées pour :</p>
        <ul className="list-disc ml-8">
          <li>Fournir nos services et exécuter les contrats</li>
          <li>Gérer les abonnements et transactions</li>
          <li>Assurer le support et la communication avec vous</li>
          <li>Améliorer nos produits, services et sécurité</li>
          <li>Respecter nos obligations légales et fiscales</li>
          <li>Envoyer du contenu promotionnel (si vous avez consenti)</li>
        </ul>
        <p>Vos données peuvent être utilisées pour :</p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          4. Communication à des tiers
        </h2>
        <p>
          Vos données peuvent être partagées avec nos prestataires de services
          (ex. Stripe pour les paiements, SendGrid pour les courriels,
          transporteurs pour la livraison). Ces tiers n’ont accès qu’aux données
          nécessaires pour fournir leur service et doivent les protéger.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          5. Conservation et destruction
        </h2>
        <p>
          Nous conservons vos données uniquement pour la durée nécessaire aux
          fins prévues, ou selon les obligations légales (ex. 7 ans pour les
          documents comptables). Si vous supprimez votre compte, vos données
          seront effacées dans un délai de 3 mois, sauf obligations légales
          contraires.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">6. Transfert hors Québec</h2>
        <p>
          Certains renseignements peuvent être hébergés ou traités à l’extérieur
          du Québec (par ex. Stripe, Supabase, SendGrid). Nous nous assurons
          qu’ils bénéficient d’un niveau de protection équivalent ou adéquat.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. Sécurité</h2>
        <p>
          Nous utilisons des mesures techniques et organisationnelles
          raisonnables (chiffrement, accès restreint, serveurs sécurisés) pour
          protéger vos données. Toutefois, aucun système n’est totalement
          sécurisé.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">8. Vos droits (Loi 25)</h2>
        <p>Vous avez le droit de :</p>
        <ul className="list-disc ml-8">
          <li>Accéder à vos renseignements personnels</li>
          <li>Demander leur rectification</li>
          <li>Demander leur suppression (droit à l’oubli)</li>
          <li>Retirer votre consentement à tout moment</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez :{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyFr;
